export enum UserType {
  Admin = "admin",
  Notary = "notary",
  NotaryDeputy = "notaryDeputy",
  ExternalUser = "externalUser",
  RegistryAgencyUser = "registryAgencyUser",
  BankUser = "bankUser",
  Mayor = "mayor",
  NapUser = "napUser",
  InvestmentBrokerUser = "investmentBrokerUser",
  InsurerUser = "insurerUser",
}
